var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 51,
    viewBox: "0 0 64 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7698 45.7762L24.184 47.1904L25.5983 45.7762L59.4142 11.9602L60.8284 10.546L59.4142 9.1318L54.8682 4.58579L53.454 3.17157L52.0398 4.58579L24.184 32.4415L11.9602 20.2177L10.546 18.8035L9.1318 20.2177L4.58579 24.7637L3.17157 26.1779L4.58579 27.5921L22.7698 45.7762Z",
    fill: "#4BB71A",
    stroke: "#4BB71A",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTickIcon);
export default __webpack_public_path__ + "static/media/success-tick-icon.3b02509a158bec64a9c55f18832a560e.svg";
export { ForwardRef as ReactComponent };